// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.client.moodys.enums.ZillowMarketReportSectionType

export enum ZillowMarketReportSectionType {
  MULTIFAMILY_RENTS = 'MULTIFAMILY_RENTS',
  NATIONAL_MARKET_OVERVIEW = 'NATIONAL_MARKET_OVERVIEW',
  RENTAL_VACANCY_RATE = 'RENTAL_VACANCY_RATE',
  RENTS = 'RENTS',
  RENT_AFFORDABILITY = 'RENT_AFFORDABILITY',
  RENT_CONCESSIONS = 'RENT_CONCESSIONS',
  SINGLE_FAMILY_RENTS = 'SINGLE_FAMILY_RENTS',
}

export const ZillowMarketReportSectionType_values = [
  ZillowMarketReportSectionType.MULTIFAMILY_RENTS,
  ZillowMarketReportSectionType.NATIONAL_MARKET_OVERVIEW,
  ZillowMarketReportSectionType.RENTAL_VACANCY_RATE,
  ZillowMarketReportSectionType.RENTS,
  ZillowMarketReportSectionType.RENT_AFFORDABILITY,
  ZillowMarketReportSectionType.RENT_CONCESSIONS,
  ZillowMarketReportSectionType.SINGLE_FAMILY_RENTS,
] as const;
